import { useState, useEffect } from 'react';
import { Bell, CheckCheck } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { authFetch } from '../../utils/authFetch';

const BACKEND = process.env.REACT_APP_BACKEND_URL;

const Notifications = () => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    authFetch(`${BACKEND}/api/dashboard/notifications`, {})
      .then(r => r.json())
      .then(d => { if (d.success) setNotifications(d.data); })
      .catch(() => {})
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const markAllRead = async () => {
    await authFetch(`${BACKEND}/api/dashboard/notifications/read-all`, { method: 'POST' });
    load();
    window.dispatchEvent(new CustomEvent('dashboard-stats-refresh'));
  };

  const unreadCount = notifications.filter(n => !n.read).length;

  const typeIcons = { new_match: '🎯', account: '👤', system: '📢' };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold">Notifications</h1>
          <p className="text-sm text-muted-foreground mt-0.5">{unreadCount > 0 ? `${unreadCount} unread` : 'All caught up'}</p>
        </div>
        {unreadCount > 0 && (
          <Button onClick={markAllRead} variant="outline" className="rounded-none gap-2 text-sm">
            <CheckCheck className="w-4 h-4" /> Mark all read
          </Button>
        )}
      </div>

      {loading ? (
        <div className="space-y-2">{[...Array(5)].map((_, i) => <div key={i} className="h-16 bg-white border border-border animate-pulse" />)}</div>
      ) : notifications.length === 0 ? (
        <div className="text-center py-20 bg-white border border-border">
          <Bell className="w-10 h-10 text-muted-foreground mx-auto mb-3" />
          <p className="font-semibold">No notifications yet</p>
          <p className="text-sm text-muted-foreground">You'll be notified when new candidates match your talent briefs.</p>
        </div>
      ) : (
        <div className="space-y-1">
          {notifications.map(n => (
            <div key={n.id} className={`bg-white border p-4 flex items-start gap-3 ${
              n.read ? 'border-border' : 'border-l-4 border-l-foreground border-border'
            }`}>
              <span className="text-lg">{typeIcons[n.type] || '🔔'}</span>
              <div className="flex-1">
                <div className="flex items-center justify-between">
                  <p className={`text-sm font-medium ${n.read ? 'text-muted-foreground' : 'text-foreground'}`}>{n.title}</p>
                  <span className="text-xs text-muted-foreground">{new Date(n.created_at).toLocaleDateString()}</span>
                </div>
                {n.message && <p className="text-xs text-muted-foreground mt-0.5">{n.message}</p>}
              </div>
              {!n.read && <div className="w-2 h-2 rounded-full bg-foreground mt-1.5 flex-shrink-0" />}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Notifications;
